import { render } from "./UserFeed2.vue?vue&type=template&id=45898ab8"
import script from "./UserFeed2.vue?vue&type=script&lang=js"
export * from "./UserFeed2.vue?vue&type=script&lang=js"

import "./UserFeed2.vue?vue&type=style&index=0&id=45898ab8&lang=css"

import exportComponent from "/Users/abayomi/Documents/dev/microservice-2/contact-mgt-app-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__